import React from 'react'
import { FormGroup, FormFeedback, Input, Col, Label } from 'reactstrap'
import { I18n } from 'react-redux-i18n'

import { ALLOWED_DOMAINS } from 'constants/index'

const RESPONSABILITIES = {
  TA: [
    { value: 'admin', label: 'responsability_admin' },
    { value: 'c-level', label: 'responsability_c_level' },
    { value: 'finance', label: 'responsability_finance' },
    { value: 'hr', label: 'responsability_human_resources' },
    { value: 'operations', label: 'responsability_operations' },
    { value: 'other', label: 'dashboard_other' },
  ],
  TMC: [
    { value: 'admin', label: 'responsability_admin' },
    { value: 'c-level', label: 'responsability_c_level' },
    { value: 'finance', label: 'responsability_finance' },
    { value: 'hr', label: 'responsability_human_resources' },
    { value: 'operations', label: 'responsability_operations' },
    { value: 'traveller', label: 'responsability_traveller' },
    { value: 'developer', label: 'responsability_developer' },
    { value: 'other', label: 'dashboard_other' },
  ],
}

/**
 *
 * @param {object} props
 * @param {string} props.name
 * @param {string} props.selected
 * @param {function} props.onChange
 * @param {boolean} [props.required=false]
 * @param {string} [props.error]
 *
 */
const UserResponsabilityField = (props) => {
  const { name, id = 'user_responsability', selected, onChange, required = false, error } = props

  const responsabilities = RESPONSABILITIES[ALLOWED_DOMAINS.type] || RESPONSABILITIES.TA

  return (
    <FormGroup row className='user-responsability mt-3'>
      <Col>
        <Label for={id}>{I18n.t('signup_user_responsability')}</Label>
        <Input
          className='form-control'
          id={id}
          name={name}
          type='select'
          defaultValue={selected}
          onChange={onChange}
          required={required}
          invalid={!!error}
        >
          {responsabilities.map((elem) => (
            <option key={elem.value} value={elem.value}>
              {I18n.t(elem.label)}
            </option>
          ))}
        </Input>
        <FormFeedback>{error}</FormFeedback>
      </Col>
    </FormGroup>
  )
}

export default UserResponsabilityField
